import React from 'react';

//Core Libs
import prd from "../../Core/Products";

// Componets
import ProductNode 		from '../../Reducer/ProductNode';
import BuildFor 		from '../../Reducer/Filters/BuildFor';
import OnSale 			from '../../Reducer/Filters/OnSale';
import Categories 		from '../../Reducer/Filters/Categories';

import { Link } from 'react-router-dom';
import DocumentMeta from 'react-document-meta';

class ProductListing extends React.Component {

	constructor(props) {
	
		super(props);

		this.state = {
			loading: true,
			products: {},
			productType: window.location.pathname.includes('cycles') ? 'CYCLE' : 'ACCESSORY',
			buildFor: '',
			onSale: '',
			catID: ''
		}
		
	}
	
	componentWillMount(){	
		this.callAPI();
	}

	callAPI = () => {
		
		let data = {
			productType: 	this.state.productType,
			buildFor: 		this.state.buildFor,
			onSale: 		this.state.onSale,
			catID: 			this.state.catID,

		};

		this.setState({
			loading: true,
		});			

		prd.getAllProducts( data, (response) => {

			this.setState({
				products: response.data,
				loading: false,
			});
			
		});

    }


    setFilters = (data) => {
    	
		let attr = [ Object.keys( data )[0] ][0];
		
		this.setState({
			[ Object.keys( data )[0] ]: data[ attr ]
		}, () => this.callAPI() );
		
	}


		
	render() {

		let products = '';

		if( this.state.loading === false ) {

			products = (
				<div className="row">
					{ 
						this.state.products.length > 0 
							? (
								this.state.products.map(function(item, i){
									return(
										<div className="col-xs-12 col-sm-6 col-md-4" key={i}>
											<ProductNode item={item} />
										</div>					
									)
								})
							) : (

								<div className="col-sm-12"> 
									<div className="empty-products-card">
										<div className="empty-icon-wrapper">
											<i className="pe-7s-search" />
										</div>
										<h3>Ingen produkter fundet</h3>
										<p>
											Vi kunne desværre ikke finde nogen produkter, der matcher dine valgte filtre.
											Prøv at rydde filtrene for at se alle varer, eller kontakt os i butikken.
										</p>
										<div className="empty-actions">
											<a href={this.state.productType === 'CYCLE' ? '/cycles' : '/accessories'} className="btn btn-primary">
												<i className="pe-7s-refresh-2" /> Nulstil filtre
											</a>
											<Link to="/contact" className="btn btn-default">
												Kontakt butikken
											</Link>
										</div>
										<div className="empty-contact-hint">
											<span>Har du brug for vejledning? Ring direkte på </span>
											<a href="tel:38288888">38 28 88 88</a>
										</div>
									</div>
								</div>
							)
					}
				</div>
			)

        } else {
			products = (
				<div className="row">
					{[1, 2, 3, 4, 5, 6].map((item) => (
						<div className="col-xs-12 col-sm-6 col-md-4" key={item}>
							<ProductNode loading={'loading'} />
						</div>
					))}
				</div>
			);
        }

        const meta = {
            title:          'Køb cykel og tilbehør fra alaska cykler København. Vi sælger verdensklasse cykler og tilbehør i københavn til meget billig pris',
            description:    'Hos Alaska cykler åbner vi dørene for en ny verden af cykelkultur. Vi tilbyder et bredt udvalg af kvalitetscykler og cykeltilbehør i København.',
            meta: {
                charset:    'utf-8',
                name: {
                    keywords: 'cykel online københavn, køb cykel københavn, cykel tilbehør københavn, shimano nexus gear cykel københavn'
                }
            }
        };

        const productCount = Array.isArray(this.state.products) ? this.state.products.length : 0;
        const productLabel = this.state.productType === 'CYCLE'
            ? (productCount === 1 ? 'cykel' : 'cykler')
            : (productCount === 1 ? 'produkt' : 'produkter');

		return (
			<div className="listing-page">
            
                <DocumentMeta {...meta} />

                <div className="container product-container">
                	<div className="row">
                		<div className="col-sm-12">
                			<ul className="filters">
                				
                				<li>
                					{
                						this.state.productType === 'CYCLE' 
                							? <BuildFor setFilters={ this.setFilters } />
                							: <Categories setFilters={ this.setFilters } />
                					}
                				</li>

                				<li className="filters-right"> 
                					<OnSale setFilters={ this.setFilters } />
                					<div className="product-count-badge">
                						{this.state.loading ? (
                							<span className="count-skeleton" />
                						) : (
                							<span>
                								Viser <strong>{productCount}</strong> {productLabel}
                							</span>
                						)}
                					</div>
                				</li>
                			</ul>
                		</div>
                	</div>

                	{products}

                </div>
			</div>
		);
	}
}

export default ProductListing;



// WEBPACK FOOTER //
// ./src/Pages/Products/Listings.js